import { CloseIcon } from './icons';

interface Toast {
  id: number;
  message: string;
  type: 'success' | 'error' | 'info';
}

interface Props {
  toasts: Toast[];
  onDismiss: (id: number) => void;
}

const TYPE_STYLES = {
  success: 'bg-atlas-pine dark:bg-atlas-pine-dark text-white',
  error: 'bg-atlas-brick dark:bg-atlas-brick-dark text-white',
  info: 'bg-atlas-brass dark:bg-atlas-brass-dark text-atlas-ink',
};

export function ToastContainer({ toasts, onDismiss }: Props) {
  if (toasts.length === 0) return null;
  return (
    <div className="fixed top-4 left-1/2 -translate-x-1/2 z-50 flex flex-col gap-2 w-80 max-w-[90vw]">
      {toasts.map(t => (
        <div
          key={t.id}
          className={`rounded-lg px-4 py-3 shadow-lg text-sm font-medium flex justify-between items-start gap-2 animate-fade-in ${TYPE_STYLES[t.type]}`}
        >
          <span>{t.message}</span>
          <button
            onClick={() => onDismiss(t.id)}
            className="opacity-80 hover:opacity-100 transition-opacity shrink-0 -mt-0.5"
          >
            <CloseIcon className="w-4 h-4" />
          </button>
        </div>
      ))}
    </div>
  );
}
